module.exports = __webpack_public_path__ + "img/woman-holding-softinya-logo.346708dc.png";